import React, {useState, useEffect} from "react";
import Spinner from "../../../spinner";
import {SERVICE_INFORMATION_MANAGEMENT} from "../../../../helpers/user_permission.helper";
import Error from "../../../error";
import {userServices} from "../../../../services";
import {formHelper} from "../../../../helpers";
import {Button, Col, notification, Row, List, Popconfirm} from "antd";
import InputField from "../../../input-field";
import i18n from "../../../../i18n";


export default function UserMessage() {
    const [loading, setLoading] = useState(false);
    const [fieldsErrors] = useState(null);
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [loadingMessages, setLoadingMessages] = useState(true);

    const getFieldErrors = (nameField) => formHelper.getFieldErrors(nameField, fieldsErrors);
    let smallButtonStyle = {height: '40px', color: 'white', backgroundColor: '#1CAA53', borderRadius: '7px', border:'none', marginBottom: "20px"};

    const user = userServices.getUser();
    if (!user.isAccessTo(SERVICE_INFORMATION_MANAGEMENT)) {
        return (<Error status={403} desc={i18n.t('main.status.403')}/>);
    }

    const loadMessages = () => {
        setLoadingMessages(true);
        userServices.getMessages().then((response) => {
            setMessages(response || []);
        }).catch(() => {
            setMessages([]);
        }).finally(() => {
            setLoadingMessages(false);
        });
    };

    useEffect(() => {
        loadMessages();
    }, []);

    const onClickCreate = () => {
        if (!message.trim()) {
            notification.error({
                message: i18n.t('settingsPage.userMessage.notification.add.title'),
                description: 'Введите текст сообщения',
                duration: 5
            });
            return;
        }
        
        setLoading(true);
        userServices.addMessage(subject, message)
            .then((response) => {
                notification.success({
                    message: i18n.t('settingsPage.userMessage.notification.add.title'),
                    description: response,
                    duration: 5
                });
                setSubject('');
                setMessage('');
                loadMessages();
            })
            .catch((errMsg) => {
                notification.error({
                    message: i18n.t('settingsPage.userMessage.notification.add.title'),
                    description: errMsg,
                    duration: 5
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onClickDeleteById = (id) => {
        setLoading(true);
        userServices.deleteMessageById(id)
            .then((response) => {
                notification.success({
                    message: i18n.t('settingsPage.userMessage.notification.delete.title'),
                    description: response,
                    duration: 5
                });
                loadMessages();
            })
            .catch((errMsg) => {
                notification.error({
                    message: i18n.t('settingsPage.userMessage.notification.delete.title'),
                    description: errMsg,
                    duration: 5
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <React.Fragment>
            <h1 className="content-header" style={{marginBottom: 5}}>{i18n.t('settingsPage.userMessage.title')}</h1>
            <Spinner loading={loading} label={null}>
                <Row gutter={16} className="modal-row-field">
                    {false && <Col span={24} className="add-padding-10">
                        <InputField name="subject" label={i18n.t('settingsPage.userMessage.subjectLabel') || 'Заголовок'} value={subject} setValue={setSubject}
                                    getFieldErrors={getFieldErrors}
                        />
                    </Col>}
                    <Col span={24} className="add-padding-10">
                        <InputField name="message" label={i18n.t('settingsPage.userMessage.inputLabel') || 'Текст сообщения'} value={message} setValue={setMessage}
                                    getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Button style={{...smallButtonStyle, marginLeft: '8px'}} htmlType="submit" key="submit" type="primary" onClick={onClickCreate}>{i18n.t('settingsPage.userMessage.buttons.set')}</Button>
                </Row>
            </Spinner>
            
            <h2 style={{marginTop: '20px', marginBottom: '10px'}}>{i18n.t('settingsPage.userMessage.listTitle') || 'Список объявлений'}</h2>
            <Spinner loading={loadingMessages} label={null}>
                {messages.length > 0 ? (
                    <List
                        bordered
                        dataSource={messages}
                        renderItem={(item, index) => (
                            <List.Item
                                actions={[
                                    <Popconfirm
                                        key="delete"
                                        title={i18n.t('settingsPage.userMessage.confirmDelete') || 'Удалить это сообщение?'}
                                        onConfirm={() => onClickDeleteById(item.id || index + 1)}
                                        okText={i18n.t('main.yes') || 'Да'}
                                        cancelText={i18n.t('main.no') || 'Нет'}
                                    >
                                        <Button type="link" danger style={{padding: 0}}>
                                            {i18n.t('settingsPage.userMessage.buttons.delete') || 'Удалить'}
                                        </Button>
                                    </Popconfirm>
                                ]}
                            >
                                <List.Item.Meta
                                    title={item.subject || `Сообщение #${index + 1}`}
                                    description={item.message}
                                />
                            </List.Item>
                        )}
                        style={{marginTop: '10px'}}
                    />
                ) : (
                    <p style={{color: '#999', fontStyle: 'italic'}}>{i18n.t('settingsPage.userMessage.noMessages') || 'Нет объявлений'}</p>
                )}
            </Spinner>
        </React.Fragment>
    );
}